import React, { createContext, useState, useContext } from 'react';
import { useAuth } from 'oidc-react';
import Project from '../../common/Utils/project';
import { useTenantSelection } from '../TenantSelectionProvider';

// Define types/interfaces
export interface TenantGroup {
  tenantGroupName: string;
  tenantGroupID: string;
}

export interface Schedule {
  repeatEvery: string;
  duration: number;
}

export interface Package {
  packageIdentifier: string;
  version: string;
}

export interface OsUpdate {
  category: string;
  kbIds: string[];
  selectUpdatesWithoutReboot: boolean;
}

export interface PolicyContent {
  thirdPartyUpdates: {
    packages: Package[];
  };
  osUpdates: {
    windows: OsUpdate;
    macOS: OsUpdate;
    linux: OsUpdate;
  };
}

export interface PolicyAutomationData {
  groupPolicyAutomationId?: string;
  policyName: string;
  tenantId: string;
  tenantGroups: TenantGroup[];
  isActive: boolean;
  schedule: Schedule;
  activationDate: string;
  policyContent: PolicyContent;
}

export interface PolicyAutomationContextType {
  PolicyAutomationData: PolicyAutomationData;
  setPolicyAutomation: React.Dispatch<React.SetStateAction<PolicyAutomationData>>;
  resetPolicyAutomationData: () => void; // 👈 add reset function
}

const PolicyAutomationContext = createContext<PolicyAutomationContextType | undefined>(undefined);

export const PolicyAutomationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { selectedTenantId } = useTenantSelection();

  const initialPolicyAutomationData: PolicyAutomationData = {
    policyName: '',
    tenantId: selectedTenantId as string,
    tenantGroups: [
      {
        tenantName: '',
        tenantGroupID: '',
      },
    ],
    schedule: {
      repeatEvery: 'Hour',
      duration: 1,
    },
    isActive: true,
    // activationDate: new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000).toISOString(),
    activationDate: new Date(new Date(new Date().setDate(new Date().getDate() + 2)).setHours(0, 0, 0, 0)).toISOString(),
    policyContent: {
      thirdPartyUpdates: {
        packages: [],
      },
      osUpdates: {
        windows: {
          category: 'Updates',
          kbIds: [],
          selectUpdatesWithoutReboot: true,
        },
        // macOS: {
        //   category: 'Updates',
        //   kbIds: ['string'],
        //   selectUpdatesWithoutReboot: true,
        // },
        // linux: {
        //   category: 'Updates',
        //   kbIds: ['string'],
        //   selectUpdatesWithoutReboot: true,
        // },
      },
    },
  };
  const [PolicyAutomationData, setPolicyAutomation] = useState<PolicyAutomationData>(initialPolicyAutomationData);

  // Reset function
  const resetPolicyAutomationData = () => {
    setPolicyAutomation(initialPolicyAutomationData);
  };

  return (
    <PolicyAutomationContext.Provider value={{ PolicyAutomationData, setPolicyAutomation, resetPolicyAutomationData }}>
      {children}
    </PolicyAutomationContext.Provider>
  );
};

export const usePolicyAutomation = () => {
  const context = useContext(PolicyAutomationContext);
  if (!context) {
    throw new Error('usePolicyAutomation must be used within a PolicyAutomationProvider');
  }
  return context;
};
